import { Flex, Spinner } from '@chakra-ui/react'

const PageLoading = () => (
  <Flex alignItems='center' justify='center' minHeight='100vh'>
    <Spinner size='md' />
  </Flex>
)

export default PageLoading
